import { useMemo } from 'react';

import { DeeplinkKeys } from '@/consts/deepLinks';
import extractUrlParams from '@/utils/ui/extractUrlParams';

const useHideBackButton = (): boolean =>
  useMemo(
    () =>
      extractUrlParams([DeeplinkKeys.hideBackButton])[
        DeeplinkKeys.hideBackButton
      ] === 'true',
    []
  );

export default useHideBackButton;
